export default [
  {
    path: '/apps/calendar',
    name: 'apps-calendar',
    component: () => import('@/views/apps/calendar/Calendar.vue'),
  },

  // *===============================================---*
  // *--------- EMAIL & IT'S FILTERS N LABELS -------------------------------*
  // *===============================================---*
  {
    path: '/apps/email',
    name: 'apps-email',
    component: () => import('@/views/apps/email/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
    },
  },
  {
    path: '/apps/email/:folder',
    name: 'apps-email-folder',
    component: () => import('@/views/apps/email/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
      navActiveLink: 'apps-email',
    },
    beforeEnter(to, _, next) {
      if (['sent', 'draft', 'starred', 'spam', 'trash'].includes(to.params.folder)) next()
      else next({ name: 'error-404' })
    },
  },
  {
    path: '/apps/email/label/:label',
    name: 'apps-email-label',
    component: () => import('@/views/apps/email/Email.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
      navActiveLink: 'apps-email',
    },
    beforeEnter(to, _, next) {
      if (['personal', 'company', 'important', 'private'].includes(to.params.label)) next()
      else next({ name: 'error-404' })
    },
  },

  // *===============================================---*
  // *--------- TODO & IT'S FILTERS N TAGS ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/todo',
    name: 'apps-todo',
    component: () => import('@/views/apps/todo/Todo.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
    },
  },
  {
    path: '/apps/todo/:filter',
    name: 'apps-todo-filter',
    component: () => import('@/views/apps/todo/Todo.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
      navActiveLink: 'apps-todo',
    },
    beforeEnter(to, _, next) {
      if (['important', 'completed', 'deleted'].includes(to.params.filter)) next()
      else next({ name: 'error-404' })
    },
  },
  {
    path: '/apps/todo/tag/:tag',
    name: 'apps-todo-tag',
    component: () => import('@/views/apps/todo/Todo.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'todo-application',
      navActiveLink: 'apps-todo',
    },
    beforeEnter(to, _, next) {
      if (['team', 'low', 'medium', 'high', 'update'].includes(to.params.tag)) next()
      else next({ name: 'error-404' })
    },
  },

  // *===============================================---*
  // *--------- CHAT  ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/chat',
    name: 'apps-chat',
    component: () => import('@/views/apps/chat/Chat.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },

  // *===============================================---*
  // *--------- ECOMMERCE  ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/e-commerce/shop',
    name: 'apps-e-commerce-shop',
    component: () => import('@/views/apps/e-commerce/e-commerce-shop/ECommerceShop.vue'),
    meta: {
      contentRenderer: 'sidebar-left-detached',
      contentClass: 'ecommerce-application',
      pageTitle: 'Shop',
      breadcrumb: [
        {
          text: 'ECommerce',
        },
        {
          text: 'Shop',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/e-commerce/wishlist',
    name: 'apps-e-commerce-wishlist',
    component: () => import('@/views/apps/e-commerce/e-commerce-wishlist/ECommerceWishlist.vue'),
    meta: {
      pageTitle: 'Wishlist',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'ECommerce',
        },
        {
          text: 'Wishlist',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/e-commerce/checkout',
    name: 'apps-e-commerce-checkout',
    component: () => import('@/views/apps/e-commerce/e-commerce-checkout/ECommerceCheckout.vue'),
    meta: {
      pageTitle: 'Checkout',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'ECommerce',
        },
        {
          text: 'Checkout',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/e-commerce/:slug',
    name: 'apps-e-commerce-product-details',
    component: () => import('@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'),
    meta: {
      pageTitle: 'Product Details',
      contentClass: 'ecommerce-application',
      breadcrumb: [
        {
          text: 'ECommerce',
        },
        {
          text: 'Shop',
          active: true,
        },
        {
          text: 'Product Details',
          active: true,
        },
      ],
    },
  },

  // *===============================================---*
  // *--------- USER ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/users/list',
    name: 'apps-users-list',
    component: () => import('@/views/apps/user/users-list/UsersList.vue'),
  },
  {
    path: '/apps/devices/list',
    name: 'apps-devices-list',
    component: () => import('@/views/apps/devices/device-list/DevicesList.vue'),
  },
  {
    path: '/apps/Assets/list',
    name: 'apps-assets-list',
    component: () => import('@/views/apps/assets/manage/AssetsList.vue'),
  },
  {
    path: '/apps/customers/list',
    name: 'apps-customers-list',
    component: () => import('@/views/apps/customer/customers-list/CustomersList.vue'),
  },
  {
    path: '/apps/factory/list',
    name: 'apps-factory-list',
    component: () => import('@/views/apps/factory/factory-list/FactoryListNew.vue'),
  },
  {
    path: '/apps/devices/swap',
    name: 'apps-devices-swap',
    component: () => import('@/views/apps/devices/device-list/DeviceSwap.vue'),
  },
  {
    path: '/apps/devices/update',
    name: 'apps-devices-update',
    component: () => import('@/views/apps/devices/device-list/DeviceBulkUpdate.vue'),
  },
  {
    path: '/apps/assets/history/:assetID',
    name: 'apps-assets-history',
    component: () => import('@/views/apps/assets/history/History.vue'),
  },
  {
    path: '/apps/assets/log/:assetID',
    name: 'apps-assets-log',
    component: () => import('@/views/apps/assets/events/AssetLog.vue'),
  },
  {
    path: '/apps/assets/telemetry/:assetID',
    name: 'apps-assets-telemetry',
    component: () => import('@/views/apps/assets/events/AssetTelemetry.vue'),
  },
  {
    path: '/apps/assets/3d/:assetID',
    name: 'apps-assets-3d',
    component: () => import('@/views/apps/assets/events/Asset3d.vue'),
  },
  {
    path: '/apps/assets/dominantfreq/:assetID',
    name: 'apps-assets-dominantfreq',
    component: () => import('@/views/apps/assets/events/AssetDominantFrequency.vue'),
  },
  {
    path: '/apps/assets/training/:assetID',
    name: 'apps-assets-training',
    component: () => import('@/views/apps/assets/events/TrainingData.vue'),
  },
  {
    path: '/apps/assets/alerts/:assetID',
    name: 'apps-assets-alerts',
    component: () => import('@/views/apps/assets/events/AssetAlerts.vue'),
  },
  {
    path: '/apps/assets/line/:lineID',
    name: 'apps-line-log',
    component: () => import('@/views/apps/assets/events/LineStatusLog.vue'),
  },
  {
    path: '/apps/users/view/:id',
    name: 'apps-users-view',
    component: () => import('@/views/apps/user/users-view/UsersView.vue'),
  },
  {
    path: '/apps/users/edit/:id',
    name: 'apps-users-edit',
    component: () => import('@/views/apps/user/users-edit/UsersEdit.vue'),
  },
  {
    path: '/apps/customers/edit/:id',
    name: 'apps-customers-edit',
    component: () => import('@/views/apps/customer/customers-edit/CustomersEdit.vue'),
  },
  {
    path: '/settings/faultcode/list',
    name: 'settings-faultcode-list',
    component: () => import('@/views/settings/fault/FaultCodes.vue'),
  },
  {
    path: '/settings/maintenance/list',
    name: 'settings-maintenance-list',
    component: () => import('@/views/settings/maintenance/Maintenance.vue'),
  },
  {
    path: '/settings/rules/list',
    name: 'settings-rules-list',
    component: () => import('@/views/settings/rules/Rules.vue'),
  },
  {
    path: '/settings/training/list',
    name: 'settings-training-list',
    component: () => import('@/views/settings/training/TrainingStatus.vue'),
  },
  {
    path: '/apps/factory/edit/:id',
    name: 'apps-factory-edit',
    component: () => import('@/views/apps/factory/factory-edit/FactoryEdit.vue'),
  },
  {
    path: '/apps/factory/site/edit/:id',
    name: 'apps-factory-site-edit',
    component: () => import('@/views/apps/factory/factory-edit/FactorySiteEdit.vue'),
  },
  {
    path: '/apps/enquiry',
    name: 'apps-enquiry',
    component: () => import('@/views/apps/enquiry/Enquiry.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
    },
  },
  {
    path: '/apps/enquiry/:folder',
    name: 'apps-enquiry-folder',
    component: () => import('@/views/apps/enquiry/Enquiry.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
      navActiveLink: 'apps-enquiry',
    },
    beforeEnter(to, _, next) {
      if (['maintenance', 'breakdown', 'lineconfig'].includes(to.params.folder)) next()
      else next({ name: 'error-404' })
    },
  },

  // Invoice
  {
    path: '/apps/invoice/list',
    name: 'apps-invoice-list',
    component: () => import('@/views/apps/invoice/invoice-list/InvoiceList.vue'),
  },
  {
    path: '/apps/invoice/preview/:id',
    name: 'apps-invoice-preview',
    component: () => import('@/views/apps/invoice/invoice-preview/InvoicePreview.vue'),
  },
  {
    path: '/apps/invoice/add/',
    name: 'apps-invoice-add',
    component: () => import('@/views/apps/invoice/invoice-add/InvoiceAdd.vue'),
  },
  {
    path: '/apps/invoice/edit/:id',
    name: 'apps-invoice-edit',
    component: () => import('@/views/apps/invoice/invoice-edit/InvoiceEdit.vue'),
  },
]
